var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBylineGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sc-byline-gradient",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 290",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .byline-gradient-r{fill:url(#byline-gradient-e);}\n            .byline-gradient-s{fill:url(#byline-gradient-d);}\n            .byline-gradient-t{fill:url(#byline-gradient-g);}\n            .byline-gradient-u{fill:url(#byline-gradient-f);}\n            .byline-gradient-v{fill:url(#byline-gradient-p);}\n            .byline-gradient-w{fill:url(#byline-gradient-o);}\n            .byline-gradient-x{fill:url(#byline-gradient-q);}\n            .byline-gradient-y{fill:url(#byline-gradient-i);}\n            .byline-gradient-z{fill:url(#byline-gradient-h);}\n            .byline-gradient-aa{fill:url(#byline-gradient-k);}\n            .byline-gradient-ab{fill:url(#byline-gradient-j);}\n            .byline-gradient-ac{fill:url(#byline-gradient-m);}\n            .byline-gradient-ad{fill:url(#byline-gradient-l);}\n            .byline-gradient-ae{fill:url(#byline-gradient-n);}\n            .byline-gradient-af{fill:url(#byline-gradient-c);}\n            .byline-gradient-ag{fill:url(#byline-gradient-b);}\n            .byline-gradient-ah{fill:#606060;}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-b",
    x1: 151.16,
    y1: 20,
    x2: 47.19,
    y2: 200.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#08143f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#29367e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3161a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1481e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-c",
    x1: 183.54,
    y1: 82.07,
    x2: 69.76,
    y2: 279.14,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-d",
    x1: 351.47,
    y1: 47.58,
    x2: 351.47,
    y2: 135.65,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-e",
    x1: 437.41,
    y1: 67.37,
    x2: 437.41,
    y2: 136.59,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-f",
    x1: 512.51,
    y1: 61.85,
    x2: 512.51,
    y2: 136.84,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-g",
    x1: 625.28,
    y1: 67.37,
    x2: 625.28,
    y2: 136.59,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-h",
    x1: 737.43,
    y1: 67.37,
    x2: 737.43,
    y2: 136.84,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-i",
    x1: 872.96,
    y1: 48.46,
    x2: 872.96,
    y2: 136.21,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-j",
    x1: 996.88,
    y1: 67.37,
    x2: 996.88,
    y2: 136.59,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-k",
    x1: 1109.02,
    y1: 61.85,
    x2: 1109.02,
    y2: 136.84,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-l",
    x1: 1229.19,
    y1: 67.37,
    x2: 1229.19,
    y2: 136.59,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-m",
    x1: 1344.72,
    y1: 67.37,
    x2: 1344.72,
    y2: 136.84,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-n",
    x1: 1451.55,
    y1: 67.37,
    x2: 1451.55,
    y2: 136.59,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-o",
    x1: 1520.44,
    y1: 67.37,
    x2: 1520.44,
    y2: 136.59,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-p",
    x1: 1595.53,
    y1: 67.37,
    x2: 1595.53,
    y2: 136.84,
    xlinkHref: "#byline-gradient-b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "byline-gradient-q",
    x1: 1712.3,
    y1: 67.37,
    x2: 1712.3,
    y2: 136.59,
    xlinkHref: "#byline-gradient-b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ag",
    d: "M116.53,0C112.67,1.92,0,172.85,0,172.85l135.81-17.28-76.17-10.56L116.53,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "byline-gradient-af",
    points: "97.24 125.79 229.33 108.51 88.56 290 169.56 138.77 97.24 125.79"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M767.21,169.09c5.1,0,10.29,.74,13.09,1.31v5.41l-.41,.41c-2.72-.49-8.23-1.15-13.01-1.15-10.62,0-14.4,2.62-14.4,8.36v1.07c0,3.85,1.4,5.9,8.81,7.62l8.31,1.97c9.88,2.46,13.91,7.21,13.91,14.92,0,9.43-5.35,16.15-21.15,16.15-7.41,0-13.09-.82-16.05-1.39v-5.82l.33-.33c4.77,.9,10.21,1.56,15.64,1.56,10.62,0,14.73-2.13,14.73-9.51v-.98c0-4.43-1.4-6.89-10.37-9.1l-8.4-1.97c-8.15-1.97-12.18-5.82-12.18-13.36,0-8.61,5.43-15.17,21.16-15.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M809.77,180.4c10.29,0,18.6,7.05,18.6,22.71,0,13.85-7.24,22.22-18.6,22.22s-18.69-8.36-18.69-22.22c0-15.66,8.31-22.71,18.69-22.71Zm0,38.94c8.73,0,12.27-4.84,12.27-14.1v-4.51c0-9.67-3.7-14.35-12.27-14.35s-12.35,4.67-12.35,14.35v4.51c0,9.35,3.62,14.1,12.35,14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M862.04,163.26v5.33l-.33,.33c-1.48-.25-3.7-.41-5.27-.41-6.01,0-8.15,1.89-8.15,6.8v5.9h12.1v5.41h-12.1v37.87h-6.26v-37.87h-8.15v-5.41h8.15v-3.77c0-9.18,4.2-14.92,14.16-14.92,2.72,0,4.77,.41,5.84,.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M890.28,219.17v5.16c-1.4,.33-4.69,.98-7.9,.98-9.55,0-12.76-6.15-12.76-15.49v-23.2h-6.5v-5.41h6.5v-9.1l3.87-2.05h2.47v11.15h13.58v5.41h-13.58v24.84c0,5.66,.58,7.87,7.08,7.87,2.47,0,5.18-.25,6.91-.49l.33,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M900.82,181.22l6.5,27.79c.58,2.38,1.48,7.21,2.06,10.49h.58c.49-3.03,1.48-8.03,2.06-10.08l7.49-28.2h8.07l7.49,28.2c.58,2.05,1.56,6.97,2.06,10.08h.58c.58-3.28,1.48-8.03,2.06-10.33l6.5-27.96h6.09l.33,.49-10.7,42.79h-8.72l-7.41-27.55c-.66-2.46-1.65-8.2-2.06-10.58h-.49c-.41,2.38-1.4,8.12-2.06,10.58l-7.41,27.55h-8.81l-10.62-42.79,.33-.49h6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M993.26,198.6v25.91h-4.44l-1.73-6.31h-.25c-1.81,4.43-6.26,7.13-13.99,7.13-8.89,0-13.91-4.92-13.91-13.2,0-7.38,4.12-12.71,15.15-12.71,6.01,0,10.62,.82,12.68,1.23h.25v-4.51c0-7.3-4.36-9.76-13.5-9.76-4.86,0-10.13,.9-12.1,1.48l-.33-.41v-5.57c2.88-.74,7.16-1.48,12.1-1.48,14.82,0,20.08,6.23,20.08,18.2Zm-6.26,16.64v-10.49c-4.36-.16-9.3-.41-14.32-.41-5.76,0-7.41,2.62-7.41,6.15v2.13c0,4.75,2.39,6.72,8.23,6.72h.99c5.6,0,9.88-1.64,12.51-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1027.17,181.14v5.57l-.33,.33c-.9-.08-1.89-.08-2.8-.08-6.75,0-10.21,1.64-12.76,4.18v33.37h-6.34v-43.29h3.95l2.31,6.23h.33c2.31-4.43,6.59-6.89,11.94-6.89,1.81,0,3.21,.33,3.7,.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1037.47,203.19v4.26c0,7.87,2.8,11.89,13.83,11.89,5.1,0,9.55-.98,12.1-2.05l.33,.33v5.41c-2.22,1.07-6.59,2.3-12.59,2.3-15.72,0-20-8.44-20-22.22,0-15.58,6.75-22.71,18.36-22.71,9.63,0,15.72,5.66,15.72,15.33v7.46h-27.74Zm0-4.84h21.48v-3.85c0-5.66-2.3-8.12-9.55-8.12h-.82c-7.41,0-10.7,3.28-11.11,11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1094.51,169.74h16.63c19.18,0,25.27,8.77,25.27,27.05s-4.2,27.71-24.37,27.71h-17.53v-54.76Zm17.53,48.78c5.02,0,9.88-.41,13.42-3.69,2.8-2.54,4.61-7.62,4.61-16.15v-3.53c0-6.56-.82-11.81-3.79-15.08-2.96-3.2-7.65-4.35-14.65-4.35h-10.78v42.79h11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1151.15,203.19v4.26c0,7.87,2.8,11.89,13.83,11.89,5.1,0,9.55-.98,12.1-2.05l.33,.33v5.41c-2.22,1.07-6.59,2.3-12.59,2.3-15.72,0-20-8.44-20-22.22,0-15.58,6.75-22.71,18.36-22.71,9.63,0,15.72,5.66,15.72,15.33v7.46h-27.74Zm0-4.84h21.48v-3.85c0-5.66-2.3-8.12-9.55-8.12h-.82c-7.41,0-10.7,3.28-11.11,11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1190.41,181.22l8.4,25.17c1.15,3.2,3.04,10.66,3.79,13.69h.41c.82-3.03,2.72-10.49,3.79-13.69l8.48-25.17h6.26l.33,.49-14.65,42.79h-8.72l-14.65-42.79,.33-.49h6.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1233.14,203.19v4.26c0,7.87,2.8,11.89,13.83,11.89,5.1,0,9.55-.98,12.1-2.05l.33,.33v5.41c-2.22,1.07-6.59,2.3-12.59,2.3-15.72,0-20-8.44-20-22.22,0-15.58,6.75-22.71,18.36-22.71,9.63,0,15.72,5.66,15.72,15.33v7.46h-27.74Zm0-4.84h21.48v-3.85c0-5.66-2.3-8.12-9.55-8.12h-.82c-7.41,0-10.7,3.28-11.11,11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1277.34,163.35v61.16h-6.34v-61.16h6.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1306.24,180.4c10.29,0,18.6,7.05,18.6,22.71,0,13.85-7.24,22.22-18.6,22.22s-18.68-8.36-18.68-22.22c0-15.66,8.31-22.71,18.68-22.71Zm0,38.94c8.73,0,12.26-4.84,12.26-14.1v-4.51c0-9.67-3.7-14.35-12.26-14.35s-12.35,4.67-12.35,14.35v4.51c0,9.35,3.62,14.1,12.35,14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1370.94,202.12c0,15.49-6.59,23.2-17.12,23.2-7.33,0-10.62-2.79-12.76-6.56l-.33,.08c.33,1.89,.66,5.98,.66,8.69v15.33h-6.34v-61.65h4.44l1.81,6.31h.25c2.39-4.18,6.17-7.13,13.01-7.13,8.56,0,16.38,5.98,16.38,21.72Zm-6.34-2.13c0-10.66-3.38-13.61-11.61-13.61-4.03,0-9.05,1.39-11.61,3.69v25.41c1.81,2.05,5.68,3.85,11.28,3.85,8.64,0,11.94-4.59,11.94-15v-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1434.73,193.6v30.91h-6.34v-32.38c0-4.26-2.47-5.74-7.49-5.74-3.62,0-7.74,1.48-9.8,3.69v34.43h-6.34v-32.38c0-4.26-2.3-5.74-7.49-5.74-3.62,0-7.74,1.39-9.71,3.61v34.51h-6.34v-43.29h4.44l1.81,6.23h.33c2.22-4.26,5.93-7.05,11.85-7.05s9.3,2.54,10.86,7.38h.33c2.47-4.84,6.42-7.38,12.1-7.38,7.33,0,11.77,4.18,11.77,13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1450.54,203.19v4.26c0,7.87,2.8,11.89,13.83,11.89,5.1,0,9.55-.98,12.1-2.05l.33,.33v5.41c-2.22,1.07-6.59,2.3-12.59,2.3-15.72,0-20-8.44-20-22.22,0-15.58,6.75-22.71,18.36-22.71,9.63,0,15.72,5.66,15.72,15.33v7.46h-27.74Zm0-4.84h21.48v-3.85c0-5.66-2.3-8.12-9.55-8.12h-.82c-7.41,0-10.7,3.28-11.11,11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1521.5,194.66v29.84h-6.34v-31.64c0-4.26-1.89-6.48-8.97-6.48-4.03,0-8.72,1.31-11.44,3.61v34.51h-6.34v-43.29h4.44l1.81,6.23h.33c2.47-4.26,6.59-7.05,13.09-7.05,7.74,0,13.42,3.94,13.42,14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1556.32,219.17v5.16c-1.4,.33-4.69,.98-7.9,.98-9.55,0-12.76-6.15-12.76-15.49v-23.2h-6.5v-5.41h6.5v-9.1l3.87-2.05h2.47v11.15h13.58v5.41h-13.58v24.84c0,5.66,.58,7.87,7.08,7.87,2.47,0,5.19-.25,6.91-.49l.33,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1602.75,169.09c5.1,0,10.29,.74,13.09,1.31v5.41l-.41,.41c-2.72-.49-8.23-1.15-13-1.15-10.62,0-14.41,2.62-14.41,8.36v1.07c0,3.85,1.4,5.9,8.81,7.62l8.31,1.97c9.88,2.46,13.91,7.21,13.91,14.92,0,9.43-5.35,16.15-21.15,16.15-7.41,0-13.09-.82-16.05-1.39v-5.82l.33-.33c4.77,.9,10.21,1.56,15.64,1.56,10.62,0,14.73-2.13,14.73-9.51v-.98c0-4.43-1.4-6.89-10.37-9.1l-8.4-1.97c-8.15-1.97-12.18-5.82-12.18-13.36,0-8.61,5.43-15.17,21.15-15.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1631.89,164c3.13,0,3.54,.82,3.54,4.59s-.41,4.51-3.54,4.51-3.54-.82-3.54-4.51,.49-4.59,3.54-4.59Zm3.21,17.22v43.29h-6.34v-43.29h6.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1700.95,193.6v30.91h-6.34v-32.38c0-4.26-2.47-5.74-7.49-5.74-3.62,0-7.74,1.48-9.8,3.69v34.43h-6.34v-32.38c0-4.26-2.3-5.74-7.49-5.74-3.62,0-7.74,1.39-9.71,3.61v34.51h-6.34v-43.29h4.44l1.81,6.23h.33c2.22-4.26,5.93-7.05,11.85-7.05s9.3,2.54,10.86,7.38h.33c2.47-4.84,6.42-7.38,12.1-7.38,7.33,0,11.77,4.18,11.77,13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1748.45,202.12c0,15.49-6.59,23.2-17.12,23.2-7.33,0-10.62-2.79-12.76-6.56l-.33,.08c.33,1.89,.66,5.98,.66,8.69v15.33h-6.34v-61.65h4.44l1.81,6.31h.25c2.39-4.18,6.17-7.13,13.01-7.13,8.56,0,16.38,5.98,16.38,21.72Zm-6.34-2.13c0-10.66-3.38-13.61-11.61-13.61-4.03,0-9.05,1.39-11.61,3.69v25.41c1.81,2.05,5.68,3.85,11.28,3.85,8.64,0,11.94-4.59,11.94-15v-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1765.08,163.35v61.16h-6.34v-61.16h6.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1780.56,164c3.13,0,3.54,.82,3.54,4.59s-.41,4.51-3.54,4.51-3.54-.82-3.54-4.51,.49-4.59,3.54-4.59Zm3.21,17.22v43.29h-6.34v-43.29h6.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1820.31,163.26v5.33l-.33,.33c-1.48-.25-3.7-.41-5.27-.41-6.01,0-8.15,1.89-8.15,6.8v5.9h12.1v5.41h-12.1v37.87h-6.26v-37.87h-8.15v-5.41h8.15v-3.77c0-9.18,4.2-14.92,14.16-14.92,2.72,0,4.77,.41,5.84,.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1828.55,164c3.13,0,3.54,.82,3.54,4.59s-.41,4.51-3.54,4.51-3.54-.82-3.54-4.51,.49-4.59,3.54-4.59Zm3.21,17.22v43.29h-6.34v-43.29h6.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1848.3,203.19v4.26c0,7.87,2.8,11.89,13.83,11.89,5.1,0,9.55-.98,12.1-2.05l.33,.33v5.41c-2.22,1.07-6.59,2.3-12.59,2.3-15.72,0-20-8.44-20-22.22,0-15.58,6.75-22.71,18.36-22.71,9.63,0,15.72,5.66,15.72,15.33v7.46h-27.74Zm0-4.84h21.48v-3.85c0-5.66-2.3-8.12-9.55-8.12h-.82c-7.41,0-10.7,3.28-11.11,11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ah",
    d: "M1920,163.35v61.16h-4.44l-1.73-6.31h-.25c-1.81,4.67-6.5,7.13-13.09,7.13-9.96,0-16.46-7.38-16.46-22.22,0-15.82,7.82-22.71,18.68-22.71,5.19,0,8.64,1.15,10.7,2.13h.25v-19.18h6.34Zm-6.34,51.73v-27.63c-2.14-.57-5.68-1.07-10.7-1.07-8.89,0-12.59,3.36-12.59,14.76v4.43c0,10.25,3.21,13.77,11.19,13.77,5.93,0,9.63-1.97,12.1-4.26Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-s",
    d: "M317.17,71.49l-2.11,9.4h98.64l-10.22,47.89-1.64,.35c-20.21,4.33-39.94,6.52-58.65,6.52s-37.93-2.19-57.06-6.52l-2.5-.56,4.67-20.86,2.54,.62c19.79,4.76,38.72,7.18,56.25,7.18,11.65,0,24.71-1.25,38.83-3.72l2.11-9.91h-98.68l10.11-47.41,1.64-.35c20.33-4.33,40.11-6.52,58.82-6.52s37.87,2.15,56.9,6.41l2.5,.55-4.66,20.96-2.53-.58c-19.7-4.55-38.58-6.85-56.11-6.85-11.64,0-24.7,1.15-38.85,3.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "byline-gradient-r",
    points: "453.64 67.37 438.82 136.59 421.19 136.59 436.02 67.37 453.64 67.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-u",
    d: "M566.38,73l-13.55,63.84h-17.62l10.6-49.89c-6.85-1.11-13.63-1.85-20.2-2.18l-9.8,46.31h-17.64l9.85-46.27c-6.56,.32-13.65,1.06-21.15,2.18l-10.58,49.85h-17.62l13.59-64.04,1.64-.35c12.89-2.72,25.56-4.32,37.71-4.76l1.27-5.84h17.64l-1.29,5.91c11.46,.56,23.11,2.14,34.67,4.69l2.49,.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-t",
    d: "M676.11,72.45c-14.81-3.37-29.71-5.09-44.27-5.09s-29.94,1.71-45.75,5.08l-1.63,.35-12.47,58.3,2.49,.54c14.89,3.29,29.83,4.95,44.39,4.95s29.9-1.66,45.61-4.94l1.64-.35,12.46-58.28-2.47-.56Zm-54.25,47.09c-9.31,0-19.15-.81-29.25-2.41l6.56-30.13c10.8-1.71,20.78-2.58,29.68-2.58s19.09,.84,29.13,2.51l-6.45,30.14c-10.79,1.64-20.77,2.47-29.68,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-z",
    d: "M791.29,73.02l-13.54,63.82h-17.62l10.6-49.9c-10.07-1.67-19.88-2.52-29.21-2.52s-18.92,.86-29.74,2.56l-10.59,49.86h-17.62l13.6-64.04,1.63-.35c15.81-3.36,31.2-5.08,45.76-5.08s29.45,1.71,44.27,5.09l2.46,.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-y",
    d: "M940.78,55.43l-4.48,21-2.55-.59c-19.73-4.56-38.64-6.88-56.19-6.88-11.66,0-24.74,1.15-38.9,3.43l-8.72,40.1c13.35,2.15,26.33,3.24,38.64,3.24,16.41,0,35.62-2.27,57.11-6.74l3.87-.8-4.59,21.32-1.64,.35c-20.21,4.22-39.94,6.36-58.64,6.36s-37.91-2.14-57.05-6.37l-2.49-.55,15.81-73.95,1.64-.35c20.33-4.33,40.11-6.52,58.82-6.52s37.86,2.15,56.9,6.41l2.48,.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ab",
    d: "M1047.7,72.45c-14.82-3.37-29.71-5.09-44.27-5.09s-29.94,1.71-45.75,5.08l-1.63,.35-12.47,58.3,2.49,.54c14.89,3.29,29.82,4.95,44.39,4.95s29.9-1.66,45.61-4.94l1.64-.35,12.46-58.28-2.47-.56Zm-54.25,47.09c-9.32,0-19.15-.81-29.25-2.41l6.56-30.13c10.79-1.71,20.77-2.58,29.68-2.58s19.09,.84,29.13,2.51l-6.45,30.14c-10.79,1.64-20.77,2.47-29.68,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-aa",
    d: "M1162.88,73l-13.55,63.84h-17.61l10.59-49.89c-6.85-1.11-13.63-1.85-20.2-2.18l-9.79,46.31h-17.64l9.84-46.27c-6.55,.32-13.65,1.06-21.14,2.18l-10.59,49.85h-17.62l13.6-64.04,1.64-.35c12.88-2.72,25.56-4.32,37.7-4.76l1.27-5.84h17.65l-1.29,5.91c11.45,.56,23.1,2.14,34.67,4.69l2.48,.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ad",
    d: "M1286.72,72.36c-14.81-3.31-29.7-5-44.25-5s-29.95,1.71-45.76,5.08l-1.63,.35-4.3,20.16h-18.04l-3.57,17.42h18.02l-5.72,26.22h17.62l5.73-26.22h23.84c16.3,0,33.54-.97,51.24-2.89l1.85-.21,3.73-17.47h.12l3.61-16.89-2.49-.55Zm-76.94,14.64c10.81-1.71,20.79-2.58,29.69-2.58s18.96,.84,28.99,2.51l-1.07,5.04c-10.16,.66-22.35,.99-36.25,.99h-22.7l1.34-5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ac",
    d: "M1398.65,67.37l-13.73,64.19-1.65,.34c-15.72,3.28-31.06,4.94-45.61,4.94s-29.5-1.66-44.39-4.94l-2.49-.55,13.69-63.97h17.63l-10.7,50.02c10.1,1.6,19.93,2.41,29.25,2.41s18.9-.83,29.68-2.47l10.69-49.96h17.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-ae",
    d: "M1500.53,72.83l-3.74,17.23-2.53-.57c-12-2.71-23.59-4.38-34.5-4.97l-11.19,52.07h-17.62l11.17-52.03c-10.66,.59-22.65,2.25-35.67,4.94l-3.88,.8,3.83-17.68,1.64-.34c15.73-3.26,31.07-4.91,45.61-4.91s29.48,1.66,44.38,4.92l2.51,.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "byline-gradient-w",
    points: "1536.66 67.37 1521.83 136.59 1504.21 136.59 1519.03 67.37 1536.66 67.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-v",
    d: "M1649.39,73.02l-13.55,63.82h-17.61l10.59-49.9c-10.06-1.67-19.88-2.52-29.2-2.52s-18.93,.86-29.74,2.56l-10.59,49.86h-17.62l13.59-64.04,1.64-.35c15.81-3.36,31.21-5.08,45.75-5.08s29.45,1.71,44.27,5.09l2.47,.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "byline-gradient-x",
    d: "M1772.39,92.96l-3.56,17.42h-17.89l-4.6,20.93-1.63,.34c-15.72,3.28-31.06,4.94-45.61,4.94s-29.5-1.66-44.39-4.95l-2.49-.54,12.47-58.3,1.63-.35c15.81-3.36,31.2-5.08,45.75-5.08s29.45,1.68,44.26,4.98l2.51,.56-3.87,17.39-2.53-.58c-15.24-3.52-29.85-5.3-43.4-5.3-8.89,0-18.86,.87-29.64,2.58l-6.56,30.13c10.08,1.6,19.89,2.41,29.19,2.41s18.86-.84,29.64-2.49l1.5-6.68h-32.81l3.56-17.42h68.48Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBylineGradient);
export default __webpack_public_path__ + "static/media/byline-gradient.cde968c638216d95b03bb202c6fc1103.svg";
export { ForwardRef as ReactComponent };